<template>
  <div>
    <b-form-group
        label="Ürün Grubu"
        label-for="id_product_categories"
    >
      <v-select
          id="id_product_categories"
          v-model="itemData.id_product_categories"
          :options="productGroups"
          label="title"
          :reduce="item => item.id"
          placeholder="Ürün Grubu"
      >

<!--        @input="getProductGroupsLow"-->
        <template v-slot:option="option">
          <div>
            {{ option.title }}
          </div>
          <div>
          </div>
        </template>
        <template v-slot:selected-option="option">
          {{ option.title }}
        </template>
      </v-select>
    </b-form-group>
<!--    <b-form-group-->
<!--        label="Ürün Grubu"-->
<!--        label-for="id_low_product_categories"-->
<!--        v-if="dataListLow"-->
<!--    >-->
<!--      <v-select-->
<!--          id="id_low_product_categories"-->
<!--          v-model="itemData.id_low_product_categories"-->
<!--          :options="dataListLow"-->
<!--          label="title"-->
<!--          :reduce="item => item.id"-->
<!--          placeholder="Ürün Grubu"-->
<!--      >-->
<!--        <template v-slot:option="option">-->
<!--          <div>-->
<!--            {{ option.title }}-->
<!--          </div>-->
<!--          <div>-->
<!--          </div>-->
<!--        </template>-->
<!--        <template v-slot:selected-option="option">-->
<!--          {{ option.title }}-->
<!--        </template>-->
<!--      </v-select>-->
<!--    </b-form-group>-->
  </div>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'ProductGroup',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    itemData() {
      return this.$store.getters['products/dataItem']
    },
    productGroups() {
      return this.$store.getters['productGroups/dataList']
    },
    dataListLow() {
      return this.$store.getters['productGroups/dataListLow']
    },
  },
  methods: {
    getProductGroupsLow(id) {
      this.$store.dispatch('productGroups/getDataList2', {
        select: [
          'product_categories.id AS id',
          'product_categories.title AS title',
          'pc.title AS main_group',
        ],
        where: {'product_categories.id_product_categories ': id},
      })
      if (!this.dataListLow || this.dataListLow.length === 0) {
        this.itemData.id_low_product_categories = null
      }
    },
  },

}
</script>
